const PATH = {
  // Home page
  HOME: '/',

  // Authentication pages
  AUTH_LOGIN: '/login',
  AUTH_REGISTER: '/register',
  AUTH_FORGOT_PASSWORD: '/forgot-password',
  AUTH_RESET_PASSWORD: '/reset-password',
  AUTH_CREATE_NEW_PASSWORD: '/create-new-password',
  AUTH_OTP: '/otp',
  AUTH_REGISTER_SUCCESS: '/register/success',

  // Article page
  ARTICLE: '/article',

  // Catalog pages
  CATALOG: '/catalog',
  CATALOG_COURSE: '/catalog?item_type=course',
  CATALOG_EVENT: '/catalog?item_type=event',

  // Course pages
  COURSE: '/course',
  COURSE_CERITIFICATE: '/course/ceritificate',

  // Event page
  EVENT: '/event',
  EVENT_DETAIL: '/event/:slug',
  // FAQ page
  FAQ: '/faq',

  // Terms and Conditions page
  TERMS_AND_CONDITION: '/terms-and-condition',

  // Ticket page
  TICKET: '/ticket',

  // Privacy Policy page
  PRIVACY_POLICY: '/privacy-policy',

  // Profile pages
  PROFILE: '/profile',
  PROFILE_MY_TICKET: '/profile#my-ticket',
  PROFILE_MY_MODULE: '/profile#my-module',
  PROFILE_MY_PERFORMANCE: '/profile#performa-saya',
  PROFILE_MY_IDP: '/profile#idp-saya',
  PROFILE_UPDATE: '/profile/update',
  PROFILE_CHANGE_PASSWORD: '/profile/change-password',

  // Payment page
  PAYMENT: '/payment',
  PAYMENT_BULK: '/payment/bulk',
  PAYMENT_ASSESSMENT: '/payment/assessment',

  // Transaction pages
  TRANSACTION: '/transaction',
  TRANSACTION_CANCELLED: '/transaction/cancelled',
  GUEST_TRANSACTION_STATUS: '/guest/transaction',

  // Program Belajar page
  LEARNING_PROGRAM: '/learning-program',

  // Detail Program Belajar page (Dynamic)
  LEARNING_PROGRAM_DETAIL: '/learning-program/:slug',

  LEARNING_PROGRAM_PACKAGE: '/learning-program/:slug/subscription-package',

  // Subscription Package page
  SUBSCRIPTION_PACKAGE: '/subscription',

  // New Landing Page
  NEW_LANDING_PAGE: '/new-landing',

  // New Landing Page
  LANDING_COURSE_PAGE: '/landing-page-courses',

  // Cart page
  CART: '/cart',

  // Assessment page
  ASSESSMENT: '/personal-learning-program/quiz',
  ASSESSMENT_CONVERSATIONAL: '/personal-journey/v2',
  ASSESSMENT_JOURNEY: '/personal-journey',
  ASSESSMENT_HISTORY: '/personal-learning-program',
  ASSESSMENT_HISTORY_DETAIL: '/personal-learning-program/:uuid',

  // Server Response
  NOT_FOUND: '/404',
};

export default PATH;
